import React from 'react';
import { CalendarIcon } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Calendar } from '../ui/calendar';
import { Button } from '../ui/button';

const toDate = (v) => (v ? new Date(`${v}T00:00:00`) : undefined);
const toValue = (d) => (d ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}` : '');

export function DateField({ value, onChange, placeholder = 'Pick a date', testId }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" className="w-full justify-start font-normal" data-testid={testId}>
          <CalendarIcon className="w-4 h-4 mr-2 text-muted-foreground" />
          {value ? toDate(value).toLocaleDateString() : <span className="text-muted-foreground">{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-testid={`${testId}-calendar`}>
        <Calendar mode="single" selected={toDate(value)} onSelect={(d) => onChange(toValue(d))} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
